import React from "react";
import { Box, Button } from "@mui/material";
import importedStyles from "../../styles/Inbox.module.css";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import EastIcon from "@mui/icons-material/East";

export default function CommentCard() {
  return (
    <Box sx={styles.wrapper}>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "13px",
        }}
      >
        <Box sx={styles.imgContainer}>
          <img
            src="https://placehold.co/190/blue/white"
            alt="social post image"
            className={importedStyles.socialPostImg}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <Box
              as="p"
              sx={{
                color: "#1a2b20",
                m: 0,
                fontFamily: "FustatBold",
                fontSize: "16px",
              }}
            >
              Priya Nair
              <Box
                as="span"
                sx={{
                  color: "#98a29a",
                  ml: 1,
                  fontFamily: "FustatMedium",
                  fontSize: "12px",
                  display: "inline-block",
                }}
              >
                @priyamakeshome
              </Box>
            </Box>

            <Box
              as="p"
              sx={{
                color: "#98a29a",
                m: 0,
                fontFamily: "FustatMedium",
                fontSize: "11px",
                textAlign: "right",
              }}
            >
              31m ago
            </Box>
          </Box>

          <Box as="p" sx={styles.commentText}>
            Is this a scam?? The link in your ad goes to a dead page. Reporting
            this to Meta
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Button sx={styles.actionBtn}>
                <FavoriteBorderIcon style={{ fontSize: "16px" }} />
                10
              </Button>
              <Button sx={styles.actionBtn}>Reply</Button>
              <Button sx={{ ...styles.actionBtn, color: "#b5642a" }}>
                Hide
              </Button>
            </Box>

            <Box>
              <Button sx={styles.actionBtn}>
                Open thread
                <EastIcon style={{ fontSize: "16px" }} />
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#ffffff",
    padding: "14px",
    borderRadius: "14px",
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
  },
  outlineBtn: {
    fontSize: "14px",
    padding: "8px 13px",
    borderRadius: "9px",
    border: "1px solid #d9d3c9",
    backgroundColor: "#ffffff",
    width: "max-content",
    color: "#33413a",
  },
  errorBtn: {
    color: "#b5642a",
    border: "1px solid #eecfba",
  },
  imgContainer: {
    height: "46px",
    width: "46px",
    borderRadius: "9999px",
    overflow: "hidden",
    border: "1px solid #f0ece5",
  },
  commentText: {
    color: "#33413a",
    mt: "4px",
    mb: "12px",
    fontFamily: "FustatRegular",
    fontSize: "14px",
  },
  actionBtn: {
    color: "rgb(58, 83, 68)",
    fontFamily: "FustatBold",
    fontSize: "13px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    gap: "4px",
    width: "fit-content",
    textTransform: "none",
    minWidth: "fit-content",
  },
};
